import { RouteConfig } from 'vue-router'

const paytracRoutes: RouteConfig = {
  path: '/paytrac',
  name: 'Paytrac',
  component: () => import('@/apps/paytrac/views/Budgettracking.vue'),
}
export default paytracRoutes
